<template>
  <CoreTimeline
    v-model="dataPoints"
    :title="title"
    :points="dataPoints"
    :calculated="calculated"
    no-data-msg="No Run Events"
    class="align-start"
  ></CoreTimeline>
</template>
<script>
import moment from 'moment'
import momentTZ from 'moment-timezone'
import { mapGetters } from 'vuex'
import COLORS from '@/util/colors'
export default {
  name: "GuidanceSchedule",
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    alerts: {
      type: Boolean,
      required: false,
      default: true
    },
    intervals: {
      type: Array,
      default: undefined
    },
    rampUpMinutes: {
      type: Number,
      required: false,
      default: 30
    },
    rampDownMinutes: {
      type: Number,
      required: false,
      default: 15
    },
    intervalLengthSeconds: {
      type: Number,
      required: false,
      default: 900
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    },
    microgrid: {
      type: Object,
      required: false,
      default: null
    },
    calculated: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      // today: {},
      dataPoints: []
    }
  },
  computed: {
    ...mapGetters(['getFacilityTimezone'])
  },
  created() {
    // let now = moment()
    // this.today.date = moment(now).format('DD')
    // this.today.dayOfWeek = moment(now).format('dddd')
    // this.today.month = moment(now).format('MMMM')
    // this.today.year = moment(now).format('YYYY')

    if (typeof this.intervals != 'undefined') {
      this.parseIntervals()
    }    

  },
  methods: {
    parseIntervals() {
      let now = momentTZ(moment()).tz(this.getFacilityTimezone)

      this.dataPoints = []
      let inRunEvent = false
      for (var i = 0; i < this.intervals.length; i++) {
        let interval = this.intervals[i]
        // FUTURE data ...
        let ending = moment(
          momentTZ(interval.ending).tz(this.getFacilityTimezone)
        )

        // console.log('now', now.format('MM/DD HH:mm'))
        // console.log('ending', ending.format('MM/DD HH:mm'))
        if (ending.isAfter(now)) {
          if (interval.guidance === 'MUST_RUN') {
            if (!inRunEvent) {
              inRunEvent = true

              /* ramp up point */
              let rampup_time = momentTZ(interval.ending)
                .tz(this.getFacilityTimezone)
                .subtract(this.rampUpMinutes, 'minutes')
              if (rampup_time.isAfter(now)) {
                let uppoint = {
                  time: rampup_time.format('MM/DD HH:mm'),
                  title: 'RAMP UP',
                  color: COLORS.hex.rampUp,
                  description: ''
                }
                this.dataPoints.push(uppoint)

                /* ramp up alert */
                let diff = rampup_time.diff(now, 'minutes')
                if (diff > 0 && diff < this.rampUpMinutes) {
                  if (this.alerts) {
                    this.$toast.info("Ramping up in " + diff + " minutes.", { timeout: 5000 } )
                  }
                }
              }
            }

            /* regular run points */
            let description = ''
            if (this.expanded) {
              description = this.expandDescription(interval)
            }

            let point = {
              time: ending.format('MM/DD HH:mm'),
              title: 'RUN @' + parseInt(interval.targetOutputKw) + ' kW',
              color: COLORS.hex.run,
              description: description
            }
            this.dataPoints.push(point)

          } else {
            /*  if-else guidance=MUST_RUN */
            // check for a ramp down
            if (inRunEvent) {
              inRunEvent = false

              let rampdown_time = momentTZ(interval.ending)
                .tz(this.getFacilityTimezone)
                .add(this.rampDownMinutes, 'minutes')
                .subtract(this.intervalLengthSeconds, 'seconds')

              let downpoint = {
                time: rampdown_time.format('MM/DD  HH:mm'),
                title: 'RAMP DOWN',
                color: COLORS.hex.rampDown,
                description: ''
              }
              this.dataPoints.push(downpoint)

              /* ramp down alert */
              let diff = rampdown_time.diff(now, 'minutes')
              if (diff > 0 && diff < this.rampUpMinutes) {
                if (this.alerts) {
                  this.$toast.info("Ramping down in " + diff + " minutes.", { timeout: 5000 } )
                }
              }
            }
          }
        }
      } /* foreach interval */

      // final timeline point is NOW
      if (this.dataPoints.length > 0) {
        this.dataPoints.splice(0, 0, {
          time: now.format('MM/DD  HH:mm'),
          title: 'NOW',
          color: COLORS.hex.time,
          desctiption: ''
        })
      }
      // console.log("dataPoints", this.dataPoints)

    },
    expandDescription(interval) {
      let firstline = true
      let description = ''

      let solarOut = parseInt(this.microgrid.solar * interval.solarMultiplier)
      if (solarOut > 0) {
        description = 'Solar: ' + solarOut + ' kW'
        firstline = false
      }

      let genOut = parseInt(
        this.microgrid.generation * interval.generatedMultiplier
      )
      if (genOut > 0) {
        if (!firstline) {
          description += '<br/>'
        }
        description += 'Generation: ' + genOut + ' kW'
      }

      let demandOut = parseInt(
        this.microgrid.demandMgmt * interval.demandMultiplier
      )
      if (demandOut > 0) {
        if (!firstline) {
          description += '<br/>'
        }
        description += 'Demand Mgmt: ' + demandOut + ' kW'
      }
      return description
    }
  }
}
</script>
<style lang="scss" scoped>
/* scrolling timeline */
.scrollMe {
  max-height: calc(110vh - 64px);
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}

/* scroll bar width */
::-webkit-scrollbar {
  width: 6px;
}

/* scroll bar track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 2px;
}

/* scroll bar handle */
::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 2px;
}

/* scroll bar handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #335b98;
}

@media screen and (max-width: 768px) {
  .container:before {
    left: 8px;
    width: 2px;
  }
}
</style>
